import EmpleadoTable from "./EmpleadoTable";
import CardLayout from "../Layout/CardLayout";
import React from "react";
import CostoFijosTable from "./CostoFijosTable";

const CostoVenta = (ciemId) => {

    const contributionForm =
        <CostoFijosTable optionName={"costoVentaTable"}
                         ciemId={ciemId}
                        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"costoVentaTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};

export default CostoVenta;